import { render } from "./PeopleMediumDevice.vue?vue&type=template&id=0bf27b37&scoped=true"
import script from "./PeopleMediumDevice.vue?vue&type=script&lang=js"
export * from "./PeopleMediumDevice.vue?vue&type=script&lang=js"

import "./PeopleMediumDevice.vue?vue&type=style&index=0&id=0bf27b37&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf27b37"]])

export default __exports__